/**
 * Logo / academy theme — navy + gold (matches marketing + Logo.png feel)
 */
export const SBA = {
  primary: '#1b365d',
  primaryContainer: '#274874',
  onPrimary: '#ffffff',
  secondary: '#c5a046',
  secondaryContainer: '#e8d59a',
  onSecondaryContainer: '#5c4510',
  tertiary: '#005f61',
  background: '#f6f4ef',
  surfaceContainer: '#eef2f7',
  surfaceContainerHigh: '#e2e8f0',
  onSurface: '#0f172a',
  onSurfaceVariant: '#475569',
  outline: '#64748b',
  outlineVariant: '#cbd5e1',
  error: '#ba1a1a',
  errorContainer: '#ffdad6',
  gold: '#c5a046',
  goldStrong: '#a8842e',
  navy: '#1b365d',
  navyDeep: '#0f2137',
  fontDisplay: "'Outfit', system-ui, sans-serif",
  fontBody: "'DM Sans', system-ui, sans-serif",
  subjectColors: {
    math: '#1b365d',
    science: '#005f61',
    'language-arts': '#8a6d1d',
    'social-studies': '#274874',
  },
};

export const SUBJECTS_THEME = [
  { id: 'math', label: 'Mathematics', icon: 'calculate', color: SBA.subjectColors.math },
  { id: 'science', label: 'Science', icon: 'science', color: SBA.subjectColors.science },
  { id: 'language-arts', label: 'Language Arts', icon: 'menu_book', color: SBA.subjectColors['language-arts'] },
  { id: 'social-studies', label: 'Social Studies', icon: 'public', color: SBA.subjectColors['social-studies'] },
];
